import { CopyTwoTone } from "@ant-design/icons";
import { Avatar, Tag } from "antd";
import { BankData } from "../../Data/BankData";
import { convertMsToHumanReadable } from "../../utils";
import moment from "moment";
import { getTableRowClassName } from "../../helpers/getRowClassName";
import { tagsColorAlert } from "../../helpers/tagsBage";

export const ColumnsVerifyCustomer = (
  nameMerchang,
  CopyTextToClipboard,
  tagsBageStatus,
  t,
  FormatTimeAgo,
  tagsBageIcon,
  expanded
) => [
    {
      title: t("ID "),
      key: "id",
      dataIndex: "id",
      width: 150,
      render: (id, record, index) => (
        <>
          <div
            style={{
              color: "#3eacff",
              fontSize: "13px",
              cursor: "copy",
              width: 150,
            }}
            onClick={() => {
              CopyTextToClipboard(id);
            }}
            className="text-wrap"
          >
            {id}
          </div>{" "}
        </>
      ),

      sorter: false,
    },

    {
      title: t("Merchant"),
      sorter: false,
      render: (_e, record) => {
        return (
          <>
            {nameMerchang}
          </>
        );
      },
    },
    {
      title: (
        <span className="text-truncate">
          {t("customer bank")} <br /> {t("customer name")}
        </span>
      ),
      dataIndex: "bank_code",
      key: "bank_code",
      render: (bank_code, record) => {
        let account_no = record?.account_number;
        let name = record?.customer?.name;
        let bankCode = bank_code === "kkp" ? "KKP" : bank_code;
        return (
          <div style={{ textTransform: "uppercase" }}>
            {bank_code ? (
              <Avatar
                size={24}
                src={BankData.find((o) => o.bankCode === bankCode)?.bankLogo}
              />
            ) : (
              ""
            )}{" "}
            -{" "}
            {account_no ? (
              <>
                {account_no}{" "}
                <CopyTwoTone
                  style={{ cursor: "copy" }}
                  onClick={() => {
                    CopyTextToClipboard(account_no);
                  }}
                />
              </>
            ) : (
              ""
            )}{" "}
            <br />
            <span className="ms-2" style={{ fontWeight: "600" }}>
              {name ? name : ""}
            </span>
          </div>
        );
      },
    },

    {
      title: t("status"),
      dataIndex: "status",
      key: "status",
      render: (status, record) => {
        // console.log(status)
        return (
          <span
            className="text-truncate"
            style={{ display: "inline-flex", alignItems: "center" }}
          >
            <Tag
              style={{ textTransform: "capitalize", fontWeight: "700" }}
              color={tagsBageStatus(status)}
              icon={tagsBageIcon(status)}
              className={getTableRowClassName(status)}
              key={status}
            >
              {status}
            </Tag>{" "}
          </span>
        );
      },
    },
    {
      title: t("Response Time"),
      filterSearch: true,
      dataIndex: "response_time_ms",
      key: "response_time_ms",
      sorter: false,
      render: (date) => {
        let e = convertMsToHumanReadable(date);

        return <code style={{ color: "#5A5A5A" }}>{e ? <>{e}</> : ""}</code>;
      },
    },
    {
      title: t("fee"),
      key: "verify_fee",
      dataIndex: "verify_fee",
      render: (item) => <>{item}</>,

      sorter: false,
    },

    {
      title: t("createdAt"),
      filterSearch: true,
      dataIndex: "createdAt",
      key: "createdAt",
      sorter: false,
      render: (date) => (
        <span
          style={{ maxWidth: "100%", display: "inline-block" }}
          className="text-truncate"
          title={moment(date).format("lll")}
        >
          {FormatTimeAgo(date)}
        </span>
      ),
    },
    {
      title: t("error_message"),
      dataIndex: "error_message",
      key: "error_message",
      render: (_, record) => {
        const rawMessage = record?.error_message || "";
        let result = rawMessage.trimStart();
        return (

          <div style={{ fontSize: "11px", width: 130, color: tagsColorAlert(record?.status) }} className="text-wrap">
            <em>{t(result)}</em>
          </div>
        );
      }
    },
  ];
